import API from 'services/API';
import { moment } from 'utils';
import operationTypesMap from 'constants/operationTypesMap';
import actionKindMap from '../../constants/actionKindMap';

const ADJUSTMENT_ACTION_KIND = 9;
const ADJUSTMENT_GROUP_TYPE = 3;

export default function getOperationsHistory(params) {
  return API.request({
    method: 'GET',
    url: '/historyOperations',
    params,
    mapper: (data) => {
      return data
        .map((operationObject) => {
          const isAccrual = operationObject.operation.type === operationTypesMap.accrual;
          const isOverpayment = isOverpaymentOperations(operationObject.actionKind);
          const isEnp =
            operationObject.taxType.title.toLowerCase() ===
            'единый налоговый платеж физического лица';
          const isAdmFile =
            operationObject.taxType.title.toLowerCase() ===
              'прочие платежи и сборы, по которым крсб не ведутся' ||
            operationObject.taxType.title.toLowerCase() ===
              'штрафы, которые невозможно отнести к конкретному налогу';
          const date = operationObject.operation.date;
          const taxType = mapTaxType(operationObject.taxType);
          const isAdjustment =
            operationObject.cancelSign ||
            (operationObject.actionKind === ADJUSTMENT_ACTION_KIND &&
              operationObject.groupType === ADJUSTMENT_GROUP_TYPE);
          const hasPositiveSum =
            isAccrual && !isAdjustment && !isOverpayment && operationObject.sum < 0;
          const sum = hasPositiveSum ? -1 * operationObject.sum : operationObject.sum;

          const operation = Object.assign({}, operationObject.operation, {
            date: moment.fromServerDatetime(date),
            actionKind: operationObject.actionKind,
            cancelSign: operationObject.cancelSign,
            index: operationObject.index,
            isAdjustment,
            isOverpayment,
            isEnp,
            isAdmFile,
          });

          return Object.assign({}, operationObject, {
            sum: sum,
            operation: operation,
            taxType: taxType,
            date: moment.fromServerDatetime(operationObject.date),
          });
        })
        .sort(sortOperations);
    },
  });
}

function isOverpaymentOperations(actionKindId) {
  return actionKindId === actionKindMap.credit || actionKindId === actionKindMap.refund;
}

function mapTaxType(taxType) {
  const title =
    taxType.title.toLowerCase() === 'налог на имущество физических лиц'
      ? 'Налог на имущество'
      : taxType.title;
  return {
    ...taxType,
    title,
  };
}

function sortOperations(operation1, operation2) {
  if (operation1.date.isBefore(operation2.date)) {
    return 1;
  } else if (operation1.date.isAfter(operation2.date)) {
    return -1;
  } else if (operation1.operation.type !== operation2.operation.type) {
    const typeDiff = operation1.operation.type - operation2.operation.type;
    return typeDiff > 0 ? 1 : -1;
  } else if (operation1.taxAuthority.code !== operation2.taxAuthority.code) {
    const codeDiff = operation1.taxAuthority.code - operation2.taxAuthority.code;
    return codeDiff > 0 ? 1 : -1;
  } else {
    const sumDiff = operation2.taxAuthority.code - operation1.taxAuthority.code;
    return sumDiff > 0 ? 1 : -1;
  }
}
